import { File as ExpoFile, Paths } from 'expo-file-system';
import * as Sharing from 'expo-sharing';
import { Platform, type PlatformOSType } from 'react-native';

export async function saveBlobAsFile(
  blob: Blob,
  filename: string,
  mimeType: string,
  platform: PlatformOSType = Platform.OS,
): Promise<void> {
  if (platform === 'web') {
    const url = URL.createObjectURL(blob);
    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.download = filename;
    anchor.click();
    URL.revokeObjectURL(url);
    return;
  }

  const bytes = new Uint8Array(await blob.arrayBuffer());
  const file = new ExpoFile(Paths.cache, filename);
  file.write(bytes);
  await Sharing.shareAsync(file.uri, { mimeType, dialogTitle: filename });
}
